import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Spinner from '../../Spinner';

export default function StreetView({ latitude, longitude, getToken, images }) {
    const [selectedImage, setSelectedImage] = useState(null);
    const [localImages, setLocalImages] = useState(images);

    console.log(selectedImage, localImages)

    const getStreetImages = (latitude, longitude) => {
        getToken().then((t) => {
            axios.get(`https://firewatch-api.space-eyes.com/google-street-images?latitude=${latitude}&longitude=${longitude}`, {
                headers: {
                    'Authorization': `Bearer ${t}`
                }
            }).then((response) => {
                setLocalImages(response.data.images)
            }).catch((err) => console.log(err));
        })
    }

    useEffect(() => {
        // Use passed images if available, otherwise fetch them
        if (images) {
            setLocalImages(images);
        } else {
            getStreetImages(latitude, longitude);
        }
      
        return () => {
            setSelectedImage(null);
        }
    }, [images, latitude, longitude]);

    useEffect(() => {
        if (localImages?.length === 1) {
            setSelectedImage(localImages[0]);
        }
    }, [localImages]);

    const gridImages = selectedImage
    ? localImages?.filter((url) => url !== selectedImage)
    : localImages;

    return (
        localImages ?
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <div style={{ fontSize: '2rem' , color: 'black' }}>Street View</div>
            <div style={{ fontSize: '0.8rem' , color: 'black', marginBottom: '0.5rem' }}>This feature offers valuable context for fire monitoring, allowing users to visually assess the surrounding terrain, infrastructure, vegetation density, and potential obstacles. By combining satellite-based simulation with ground-level perspective, it enhances situational awareness for emergency planners, responders, and analysts.</div>
            {selectedImage && <img style={{ width: '100%', height: 260 }} src={selectedImage}/>}
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 5 }}>
                {gridImages?.map((i, index) => {
                    return <img key={index} src={i} onClick={() => setSelectedImage(i)} style={{ width: '49%', height: 150, cursor: 'pointer' }}/>
                })}
            </div>
        </div>
        :
        <Spinner />
    )
}